@if (isPublicNavigationEnabled()) {
  <div class="header-logged-out">
    <ftr-logo [theme]="logoThemes.Themed" [static]="true" />
    <button
      ftrIconButton
      icon="HelpCircleLine"
      iconColor="Grey40"
      size="medium"
      #helpAndSupportPopover="ngbPopover"
      [ngbPopover]="helpAndSupportTemplate"
      [animation]="false"
      [triggers]="'manual'"
      (click)="helpAndSupportPopover.toggle()"
    >
      Help & Support
    </button>
  </div>

  <ng-template #helpAndSupportTemplate>
    <ftr-help-sub-menu-flyout-card [helpMenuConfig]="{ mode: 'loggedout' }" />
  </ng-template>
} @else {
  <div class="header-logged-out-legacy row align-items-center justify-content-center">
    <ftr-logo [theme]="logoThemes.Themed" [size]="logoSizes.Legacy" />
    <div class="help-button">
      <button
        class="elevio__help"
        ftrTooltip
        message="Help Center"
        [showDash]="false"
        alignment="center"
        position="left"
      >
        <ftr-icon-legacy icon="HelpCircleSolid" color="Primary" align="Top" size="ExtraLarge" />
      </button>
    </div>
  </div>
}
